<template src="./product.html"></template>

<script>
import axios from 'axios';
import header from '../header/header';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'VendingMachineProduct',
  components: {
    recommendationHeader: header,
    Carousel,
    Slide,
  },
  data() {
    return {
      showModals: false,
      productsTemp: [
        {
          id_product: 263,
          master_ean: '',
          name: 'Beautiful Color Lipstick',
          brand: 'Elizabeth Arden',
          id_image: 1218,
          product_image_url:
            'https://s3-ap-southeast-1.amazonaws.com/sociolla-uat/img/p/1/2/1/8/1218-large_default.jpg',
          position: 1,
          row: 1,
          column: 1,
        },
        {
          id_product: 1024,
          master_ean: '',
          name: 'Beauty Blender',
          brand: 'Masami Shouko',
          id_image: 2019,
          product_image_url:
            'https://s3-ap-southeast-1.amazonaws.com/sociolla-uat/img/p/2/0/1/9/2019-large_default.jpg',
          position: 2,
          row: 1,
          column: 2,
        },
        {
          id_product: 1928,
          master_ean: '8993536082447',
          name: 'Mini Beauty Blender (Neon Pink)',
          brand: 'Armando Caruso',
          id_image: 4214,
          product_image_url:
            'https://s3-ap-southeast-1.amazonaws.com/sociolla-uat/img/p/4/2/1/4/4214-large_default.jpg',
          position: 3,
          row: 1,
          column: 3,
        },
        {
          id_product: 1930,
          master_ean: '8993536082553',
          name: ' Mini Slanted Beauty Blender (Black)',
          brand: 'Armando Caruso',
          id_image: 9314,
          product_image_url:
            'https://s3-ap-southeast-1.amazonaws.com/sociolla-uat/img/p/9/3/1/4/9314-large_default.jpg',
          position: 4,
          row: 1,
          column: 4,
        },
        {
          id_product: 1934,
          master_ean: '8993536082881',
          name: 'Beauty Blender with Handle (White)',
          brand: 'Armando Caruso',
          id_image: 4221,
          product_image_url:
            'https://s3-ap-southeast-1.amazonaws.com/sociolla-uat/img/p/4/2/2/1/4221-large_default.jpg',
          position: 5,
          row: 1,
          column: 5,
        },
        {
          id_product: 1937,
          master_ean: '8993536082997',
          name: 'Slanted Beauty Blender with Handle (Black)',
          brand: 'Armando Caruso',
          id_image: 4222,
          product_image_url:
            'https://s3-ap-southeast-1.amazonaws.com/sociolla-uat/img/p/4/2/2/2/4222-large_default.jpg',
          position: 6,
          row: 1,
          column: 6,
        },
        {
          id_product: 2224,
          master_ean: '',
          name: 'Beauty Bliss BB Cream',
          brand: 'Emina',
          id_image: 4694,
          product_image_url:
            'https://s3-ap-southeast-1.amazonaws.com/sociolla-uat/img/p/4/6/9/4/4694-large_default.jpg',
          position: 7,
          row: 1,
          column: 7,
        },
      ],
      selectedProduct: '',
      processing: false,
    };
  },
  computed: {
    products() {
      return this.$store.state.vm.productsVm;
    },
    currentIndex: {
      get() {
        return this.$refs.carousel ? this.$refs.carousel.currentPage : 0;
      },
    },
  },
  created() {},
  methods: {
    chooseProduct() {
      if (!this.processing) {
        this.processing = true;
        this.$router.push('/vending-machine/success');
        let location = this.selectedProduct.row + '' + this.selectedProduct.column;
        location = Number(location) - 10;
        // console.log(location)
        axios
          .post('http://localhost:9000/vm_api/shipping', {
            position: location,
          })
          .then((response) => {
            this.processing = false;
            if (response == 'Success Shipping') {
              this.$router.push('/vending-machine/success');
            } else {
              this.$toasted.global.error('Shipping Failed.');
            }
          })
          .catch((error) => {
            this.processing = false;
          });
      }
    },
    withDraw() {
      this.toggleModal();
      this.selectedProduct = this.products[this.currentIndex];
      this.$store.commit('setSelectedProductVm', this.selectedProduct);
    },
    toggleModal() {
      this.showModals = this.showModals ? false : true;
      if (!this.showModals) {
        this.selectedProduct = '';
      }
    },
    imageError(e) {
      e.target.src = '/static/img/mask-station/default-image-product.png';
    },
  },
};
</script>

<style lang="scss">
@import 'product';
#app {
  .VueCarousel {
    .VueCarousel-navigation-button {
      background-color: #ffffff;
      height: 110px;
      width: 110px;
      border-radius: 70px;
      outline: none;
      box-shadow: 0.5px 2px 4px 0 #c9c9c9;
      display: flex;
    }
    .VueCarousel-pagination {
      width: 100%;
      text-align: center;
      padding-top: 19px;
    }

    .VueCarousel-navigation--disabled {
      opacity: 1;
    }

    .VueCarousel-navigation-prev {
      &.VueCarousel-navigation--disabled {
        display: block;
        background: #ffffff;
        &:before {
          background: transparent url('~static/img/vending-machine/arw-rgt-big.svg') no-repeat right 0;
          width: 36px;
          height: 53px;
          transform: rotate(90deg);
        }
      }
    }

    .VueCarousel-navigation-next {
      background-color: #f083a6;
      left: auto;
      right: 6%;
      top: 38%;
      padding: 27px 35px 22px !important;
      background-image: url('~static/img/vending-machine/arw-wht-big.svg');
      background-repeat: no-repeat;
      background-position: 38px 27px;
      transform: rotate(270deg);
    }

    .VueCarousel-navigation-next {
      &.VueCarousel-navigation--disabled {
        display: block;
        background-color: #ffffff;
        background-image: url('~static/img/vending-machine/arw-rgt-big.svg');
        background-repeat: no-repeat;
        background-position: 38px 27px;
        transform: rotate(270deg);
      }
    }

    .VueCarousel-navigation-prev {
      background: #f083a6;
      left: 17%;
      top: 44%;
      padding: 27px 35px 22px !important;
      &:before {
        content: '';
        display: inline-block;
        background: transparent url('~static/img/vending-machine/arw-wht-big.svg') no-repeat left top;
        width: 36px;
        height: 53px;
        background-size: cover;
        transform: rotate(90deg);
      }
    }

    .VueCarousel-dot:focus {
      outline: none;
    }
  }
}
</style>
